// Mirrored in applications/platform-app/components/web-analytics — change both.
import React from 'react';
import { RUBY } from '../format';

/** Area + line, optional dashed previous-period overlay. Ported from the mockup's lineChart(). */
export const LineChart: React.FC<{
  values: number[];
  previous?: number[];
  labels: string[];
  height?: number;
  color?: string;
  format?: (v: number) => string;
}> = ({ values, previous, labels, height = 220, color = RUBY, format = (v) => String(Math.round(v)) }) => {
  const W = 900, H = height, pad = 28, padL = 48, n = values.length;
  const mx = Math.max(0, ...values, ...(previous || [])) * 1.12 || 1;
  const x = (i: number) => padL + (i * (W - padL - pad)) / Math.max(1, n - 1);
  const y = (v: number) => H - pad - (v / mx) * (H - pad * 2);
  const path = (arr: number[]) => arr.map((v, i) => `${i ? 'L' : 'M'}${x(i).toFixed(1)},${y(v).toFixed(1)}`).join('');
  const area = n ? `${path(values)}L${x(n - 1)},${H - pad}L${x(0)},${H - pad}Z` : '';
  const step = Math.ceil(n / 8);
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" preserveAspectRatio="none" style={{ display: 'block', height: H }} role="img" aria-label="Line chart">
      {[0, 1, 2, 3, 4].map((k) => {
        const yy = pad + (k * (H - pad * 2)) / 4;
        return (
          <g key={k}>
            <line x1={padL} x2={W - pad} y1={yy} y2={yy} stroke="#f0efee" />
            <text x={padL - 6} y={yy + 3} fontSize={10} fill="#a8a29e" textAnchor="end">{format(mx * (1 - k / 4))}</text>
          </g>
        );
      })}
      {n > 0 && <path d={area} fill={color} opacity={0.08} />}
      {previous && previous.length > 0 && (
        <path d={path(previous.slice(0, Math.max(n, previous.length)))} fill="none" stroke="#a8a29e" strokeWidth={1.5} strokeDasharray="4 4" data-testid="wa-compare-line" />
      )}
      {n > 0 && <path d={path(values)} fill="none" stroke={color} strokeWidth={2.2} />}
      {values.map((v, i) => (
        <circle key={i} cx={x(i)} cy={y(v)} r={9} fill="transparent">
          <title>{`${labels[i] ?? ''}: ${format(v)}${previous && previous[i] !== undefined ? ` (prev ${format(previous[i])})` : ''}`}</title>
        </circle>
      ))}
      {labels.map((t, i) => (n <= 12 || i % step === 0 ? (
        <text key={i} x={x(i)} y={H - 8} fontSize={10} fill="#a8a29e" textAnchor="middle">{t}</text>
      ) : null))}
    </svg>
  );
};
